import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import { Flex } from 'ui/acro'
import { ChevronRightIcon } from 'components_v2/Icons'
import { Count } from 'components_v2/Header/Navbar/Menus/Desktop/RightContent/Search/SearchDrawer/common'
import { H1 } from 'ui/bend'
import { useWindowResize } from 'hooks'

const FlexHeader = styled(Flex)`
  ${css({
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: [null, null, null, '15px'],
    pb: '15px'
  })}
`
const Title = styled(H1)`
  ${css({
    fontSize: ['24px', '29px', '30px'],
    color: 'black'
  })}
`
export const ResultsCount = styled(Count)`
  ${css({
    color: ['#636363', '#636363', '#636363', 'black'],
    minWidth: 'fit-content'
  })}
`
const GapContainer = styled(Flex)`
  ${css({
    alignItems: 'center',
    gap: '10px'
  })}
`

const TopResultsSectionHeader = ({
  title,
  count,
  onClick,
  padding,
  display = 'flex'
}) => {
  const [size, setSize] = useState()
  const { width } = useWindowResize()
  useEffect(() => {
    setSize(width < 1200 ? 'mobile' : 'desktop')
  }, [width])
  const isDesktop = size === 'desktop'

  const resultOrResults = count && count !== 1 ? 'results' : 'result'

  return (
    <FlexHeader padding={padding} display={display}>
      <GapContainer>
        <Title>{title}</Title>
      </GapContainer>
      <GapContainer onClick={onClick} as='a' id={`Top-${title}CountSeeAll`}>
        <ResultsCount
          borderBottom={['none', 'none', 'none', '1px solid black']}
        >
          {isDesktop ? `View ${count} ${resultOrResults}` : `${count}`}
        </ResultsCount>
        <ChevronRightIcon color={isDesktop ? 'black' : '#636363'} />
      </GapContainer>
    </FlexHeader>
  )
}

TopResultsSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  padding: PropTypes.string
}

export default TopResultsSectionHeader
